import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.button `
  display: inline-flex;
  align-items: center;
  background: none;
  color: ${brand.black};
  border: 0;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  text-decoration: none;
  text-underline-position: under;

  &.focus-ring,
  &:hover {
    text-decoration: underline;
  }
`;
const Text = styled.span `
  display: block;
  color: currentColor;
  ${fonts.brandonGrotesque.bold};
  font-size: 12px;
  line-height: 1em;
  letter-spacing: 0.01em;
  text-transform: uppercase;
`;
const Icon = styled.span `
  display: block;
  height: 10px;
  margin-right: 8px;
  width: 10px;
`;
const ClearButtonStyles = {
    Container,
    Icon,
    Text,
};
export default ClearButtonStyles;
